import { Injectable, OnDestroy } from '@angular/core';
import { LocalizationService } from '../localize/localization.service';
import { environment } from 'src/environments/environment';
import { HttpWrapperService } from '../http/http-wrapper.service';
import { takeUntil } from 'rxjs/operators';
import { LoadingController } from '@ionic/angular/standalone';
import { AppStateService } from '../../init/app-state.service';
import { InitializationService } from './initialization.service';
import { CommonService } from '../../common.service';
import { NetworkProvidersService, ConnectionStatus } from '../networkProviders/network-providers.service';
import { StorageService } from '../storage/storage.service';
import { CookieService } from 'ngx-cookie-service';
import { SignUpService } from '../../sign-up.service';
import { InitService } from '../../init/init.service';
import { analyticsData } from '../../../analytics.constants';
import { AnalyticsService } from '../analytics/analytics.service';
import { Subject, timer } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WelcomeService implements OnDestroy {
  welcomeScreenData: any;
  preferredLanguage: any;
  uuid: any;
  loadingDialog: any = null;
  internetStatus = false;
  checkUUID: number;
  private destroy$ = new Subject<void>();
  constructor(private localization: LocalizationService, public httpWrapper: HttpWrapperService,
    private InitializationService: InitializationService,
    private commonServ: CommonService, private networkService: NetworkProvidersService,
    public loadingController: LoadingController,
    private cookieService: CookieService,
     public storageServ: StorageService, public appState: AppStateService, public signupService: SignUpService, 
     private initService: InitService,
     private analyticsService: AnalyticsService,
  ) { }


  ccAvanuePayment() {
    console.log("ccAvanuePayment called from welcome service")
    var paymentData = JSON.parse(localStorage.getItem(environment?.headers?.program_id + ":" + "paymentData"))
    var gstDetails = JSON.parse(localStorage.getItem(environment?.headers?.program_id + ":" + "gstDetails"));
    console.log("ccAvanuePayment called from welcome service312", paymentData, "gstDetails", gstDetails);
    if (paymentData && gstDetails) {
      console.log("ccAvanuePayment called from welcome service312423423", paymentData, "gstDetails", gstDetails);
      this.signupService
        .activateMembership(gstDetails, paymentData)
        .then((res: any) => {
          if (res) {

            console.log("res from activate membership", res);
            // this.transactionCode = paymentData.transactionId ? { transactionNumber: paymentData.transactionId } : null;
            res.spouseMemberhsip
            // this.createdMembership = res;
            // if (this.gstDetailsForm.value.gstNumber && this.gstDetailsForm.value.regCompanyName) {
            //     this.gsttext = true
            // } else {
            //     this.gsttext = false
            // }
            // this.spouseMembershipService.spouseCurrency = res.spouseMembership.currency;
            let memberidEncrpit = this.appState.getEncryptedMemberId();
            // this.isAPIProcessing = false;
            // this.callAnalytics(analyticsData.partnerPaymentSuccessPopUpFeeTrackState, analyticsData.partnerPaymentSuccessPopUpFee, memeberidEncrpit);
            let analyticData = analyticsData.welcomeToMembershipStateCdata;
            this.analyticsService.trackState(analyticData['cd.pagename'], analyticData, memberidEncrpit);
            // const modal = document.getElementById('customise');
            // modal.style.display = 'flex';

          }
          // else {
          //     this.disablePaymentButton(false);
          // }
        }
        );
    }

  }
  
  getWelcomeScreenSliderImagesWelcome() { // AEM API FOR WELCOME SCREEN SLIDER IMAGE
    const appData = this.appState.getAppData()
    console.log("getWelcomeScreenSliderImagesWelcome", this.localization.DEVICE_LANGUAGE);
    let data = {
      "country": appData?.appInitData?.countryAEM || environment?.countryAEM,
      "language": this.localization.getDeviceLanguage(),
      "brand": environment.brand,
      "program": environment.program,
      "subprogram": environment.subprogram,
      "type": 'CustomerApp'
    }
    //console.log("welcome-screen request data======>>>>>>", data);
   return this.httpWrapper.postAemData(`${environment.aem_base_url}api/tlc/welcome-screen`, data) //refactored code non-blocked task
  .then((res: any) => {
    //console.log("AEMDATAHERE==>>>" + res);
    let dataAem = (typeof res === 'string') ? JSON.parse(res) : res;
    //console.log("data AEM =======>>>>>", dataAem);
    this.welcomeScreenData = dataAem.JsonResponse;
    return this.welcomeScreenData;
  })
  .catch((err) => {
    //console.log('err screen Home Screnn ====>>>', err);
  });

  }



  initializeApp() {
    console.log("initializeApp");
        console.log("platform ready initializeApp");
        this.setDeviceUUID();
        this.InitializationService.checkInternetConnection();
        //refactoring the code
        timer(5000).pipe(takeUntil(this.destroy$)).subscribe(() => {
          this.InitializationService.checkEssentailData();
        });
        this.networkService.onNetworkChange().subscribe((status: ConnectionStatus) => {
          if (status == ConnectionStatus.Online) {
            this.selectTag();
            this.setAppId()
            this.initServiceCalled();
          }
        });
   
  }

  
  ngOnDestroy() {
  this.destroy$.next();
  this.destroy$.complete();
}


  async setDeviceUUID() {
    if (this.commonServ.uuid == undefined || null) {
      this.checkUUID = Math.floor(1000000000 * Math.random());
      if (!this.cookieService.get('uuid')) {
        this.commonServ.uuid = 'webUUID' + this.checkUUID;
        this.cookieService.set('uuid', this.commonServ.uuid, 90);
      }
    }
   
  }



  selectTag() {
    const ionSelects = document.querySelectorAll("ion-select");
    ionSelects.forEach(sel => {
      if (sel.shadowRoot) {
        sel.shadowRoot.querySelectorAll(".select-icon-inner").forEach(elem => {
          elem.setAttribute("style", "display: none;");
        });
      }
    });
  }

  initServiceCalled() {
    this.initService.initializeApp().then(async res => {
      console.log('Init App of appcomponent is Called!!', res);
    });
  }


  /******** Here we are getting APP version ********/
  setAppId() {
    this.commonServ.apkversion = '4.0.0';
  }




}
